import { render, staticRenderFns } from "./MarkerGuide.vue?vue&type=template&id=0b56d6c4"
import script from "./MarkerGuide.vue?vue&type=script&lang=js"
export * from "./MarkerGuide.vue?vue&type=script&lang=js"
import style0 from "./MarkerGuide.vue?vue&type=style&index=0&id=0b56d6c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports